import {Helmet} from 'react-helmet'

export const GooglePixel=()=>{
    return(
        <Helmet>
            <script async src="https://www.googletagmanager.com/gtag/js?id=AW-17134123828"></script>
            <script>
                {`
                            window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());

                gtag('config', 'AW-17134123828');
            `}
            </script>
        </Helmet>
    )
}